import styled from "styled-components";

export const Styles = styled.div`
  .content {
    margin-bottom: 8rem;
  }
`;

export const SQuestion = styled.div`
  --alpha-user: 0.5;
  --alpha: 0.2;

  padding: 0.5em;

  .reply-button {
    position: absolute;
    right: 0.5em;
    top: 0.5em;
  }

  .reply-button,
  .reference-buttons {
    color: rgba(var(--text-primary-dark-rgb), 0.5);

    :hover {
      color: var(--text-primary-dark);
    }
  }

  .parent-text {
    transform: scale(0.9);
  }

  .card {
    border: none;
    background-color: var(--primary-dark);
    color: var(--text-primary-dark);

    border-radius: 1rem;
  }

  .card-body {
    padding: 0.5em;
  }

  .card-title {
    color: var(--text-primary-light);
  }

  .card-text {
    color: var(--text-primary-light);
  }

  .message-title {
    font-weight: light;
    color: var(--text-primary-dark);
  }

  .message-time {
    color: var(--text-primary-dark);
    font-weight: 400;
    margin: 0;
  }

  .line-white {
    height: 5px;
    background-color: var(--text-primary-dark);
  }

  .answers {
    width: 100%;
    margin: 0.5rem 0.5rem 0 0.5rem;
    border-radius: 1rem;
    background-color: rgba(var(--accent-primary-dark-rgb), 0.5) !important;
    padding-bottom: 0.5rem;
  }

  .answers .answer {
    display: flex;
    flex-direction: column;
    margin-top: 0.25rem;
    padding-top: 0.5rem;

    border-top: 2px solid var(--text-primary-dark);
  }

  .show-answers {
    background-color: var(--primary-light);
    color: var(--text-primary-light);
    border-width: 0;
    border-radius: 1rem;
    padding: 0.2rem;
  }
`;

export const SAnswer = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  margin-top: 0.25rem;
  padding-top: 0.5rem;

  ${(props) => !props.isFirst && "border-top: 2px solid var(--text-primary-dark);"}
`;
